/* eslint-disable @typescript-eslint/no-explicit-any */
import { RoleTypes } from "models/role-types.model";
import { useAuth } from "providers/auth.provider";
import React, { useMemo } from "react";

interface Props {
  /**
   * Roles necessárias. Será verificado se possui ao menos 1 das roles. O array simboliza um expressão OR.
   */
  rolesRequired: RoleTypes[];
  unauthorizedComponent?: React.ReactElement | null;
  children: React.ReactNode | null;
}

export const ProtectedComponent = ({
  rolesRequired,
  unauthorizedComponent,
  children
}: Props) => {
  const { signedIn, info } = useAuth();

  const canAccess = useMemo(() => {
    if (rolesRequired.length === 0) {
      return true;
    }

    if (!info?.roles || info.roles.length === 0) {
      return false;
    }

    const userRoles = info.roles.map(x => x.toUpperCase());
    const requiredRoles = rolesRequired.map(x => x.toUpperCase());

    return userRoles.some(x => requiredRoles.includes(x));
  }, [rolesRequired, info?.roles])

  if (!signedIn || !canAccess) return unauthorizedComponent ?? null;

  return <>{children}</>;
};
